// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .save-face-container {
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.save-face-container h2 {
  margin-bottom: 20px;
  font-size: 24px;
}

.name-input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  margin-bottom: 20px;
  border: 2px solid #ccc;
  border-radius: 5px;
}

.video-container {
  margin-bottom: 20px;
}

.face-buttons {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.instruction {
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  z-index: 1000;
} */


/* Container Styling */

/* Main container */


.save-face-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px 30px;
  background: linear-gradient(to bottom right, #ffffff, #f1f5f9);
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  height: auto;
  max-height: 800px;
  overflow: hidden;
  position: relative;
}

.save-face-container h2 {
  margin-bottom: 10px;
  font-size: 24px;
  color: #222;
  letter-spacing: 0.5px;
}

.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 640px;
  margin-bottom: 20px;
  padding: 10px;
  position: relative; /* For canvas overlay */
}

#video {
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  max-width: 100%;
  height: auto;
}

#captureCanvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.face-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.btn {
  padding: 12px 24px;
  background-color: #79C42B;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 180px;
}

.btn:hover:not(:disabled) {
  background-color: #79C42B;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 123, 255, 0.2);
}

.btn:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  opacity: 0.8;
}

.instruction {
  position: relative;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #4caf50;
  color: #fff;
  padding: 10px 10px;
  border-radius: 6px;
  font-size: 14px;
  z-index: 12000;
  max-width: 90%;
  text-align: center;
}


.disclaimer-note {
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  margin: 10px 0;
  font-size: 12px;
  color: #333;
  text-align: center;
}

.disclaimer-note p {
  margin: 0;
}

.disclaimer-note strong {
  color: #007bff;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@media (max-width: 768px) {
  .save-face-container {
    width: 90%;
    margin: 20px auto;
    padding: 15px;
  }

  .save-face-container h2 {
    font-size: 24px;
  }

  .video-container {
    width: 100%;
    max-width: 100%;
    padding: 10px;
  }

  #video {
    width: 100%;
    height: auto;
    max-height: 400px;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }

  .face-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .btn {
    min-width: 100%;
    padding: 12px 24px;
  }

  .instruction {
    top: 5px;
    font-size: 13px;
    padding: 8px 12px;
    max-width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/SaveFaceData.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2DG;;;AAGH,sBAAsB;;AAEtB,mBAAmB;;;AAGnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,4DAA4D;EAC5D,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;AACA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;EAC5C;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;AACF","sourcesContent":["/* .save-face-container {\n  max-width: 800px;\n  margin: 50px auto;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.save-face-container h2 {\n  margin-bottom: 20px;\n  font-size: 24px;\n}\n\n.name-input {\n  width: 100%;\n  padding: 10px;\n  font-size: 16px;\n  margin-bottom: 20px;\n  border: 2px solid #ccc;\n  border-radius: 5px;\n}\n\n.video-container {\n  margin-bottom: 20px;\n}\n\n.face-buttons {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  margin: 10px;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\nbutton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n.instruction {\n  position: fixed;\n  top: 20px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 10px;\n  z-index: 1000;\n} */\n\n\n/* Container Styling */\n\n/* Main container */\n\n\n.save-face-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 20px 30px;\n  background: linear-gradient(to bottom right, #ffffff, #f1f5f9);\n  border-radius: 16px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  height: auto;\n  max-height: 800px;\n  overflow: hidden;\n  position: relative;\n}\n\n.save-face-container h2 {\n  margin-bottom: 10px;\n  font-size: 24px;\n  color: #222;\n  letter-spacing: 0.5px;\n}\n\n.video-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: 20px;\n  padding: 10px;\n  position: relative; /* For canvas overlay */\n}\n\n#video {\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  max-width: 100%;\n  height: auto;\n}\n\n#captureCanvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n\n.face-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  margin-top: 20px;\n}\n\n.btn {\n  padding: 12px 24px;\n  background-color: #79C42B;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 180px;\n}\n\n.btn:hover:not(:disabled) {\n  background-color: #79C42B;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0, 123, 255, 0.2);\n}\n\n.btn:disabled {\n  background-color: #a0aec0;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.instruction {\n  position: relative;\n  top: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #4caf50;\n  color: #fff;\n  padding: 10px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  z-index: 12000;\n  max-width: 90%;\n  text-align: center;\n}\n\n\n.disclaimer-note {\n  background-color: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 8px;\n  margin: 10px 0;\n  font-size: 12px;\n  color: #333;\n  text-align: center;\n}\n\n.disclaimer-note p {\n  margin: 0;\n}\n\n.disclaimer-note strong {\n  color: #007bff;\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n@media (max-width: 768px) {\n  .save-face-container {\n    width: 90%;\n    margin: 20px auto;\n    padding: 15px;\n  }\n\n  .save-face-container h2 {\n    font-size: 24px;\n  }\n\n  .video-container {\n    width: 100%;\n    max-width: 100%;\n    padding: 10px;\n  }\n\n  #video {\n    width: 100%;\n    height: auto;\n    max-height: 400px;\n    object-fit: cover;\n    border-radius: 10px;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  }\n\n  .face-buttons {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .btn {\n    min-width: 100%;\n    padding: 12px 24px;\n  }\n\n  .instruction {\n    top: 5px;\n    font-size: 13px;\n    padding: 8px 12px;\n    max-width: 95%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
